import React from "react"

export default function SatispayForm() {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div className="fr-margin-top-large">
      <p className="fr-p3">
        {I18n.t("cart_summary.satispay.description")}
      </p>
    </div>
  )
}
